import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavGestionDonneesComponent } from './nav-gestion-donnees/nav-gestion-donnees.component';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [NavGestionDonneesComponent],
	imports: [RouterModule, CommonModule],
	exports: [NavGestionDonneesComponent]
})
export class GestionDonneesModule {}
